import Immutable from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { UserQuery } from 'records/UserQuery';
import queryUsers from 'utils/queryUsers';

export interface UserQueryActions {
  setUserQuery: (
    actionParams: AppStateActionParams,
    nextUserQuery: UserQuery
  ) => AppState;

  queryUsers: (actionParams: AppStateActionParams) => AppState;
  initUsersQuery: (actionParams: AppStateActionParams) => AppState;
}

const userQueryActions: UserQueryActions = {
  setUserQuery: (
    { state }: AppStateActionParams,
    nextUserQuery: UserQuery
  ): AppState => {
    const { users, roles, groupsByMember } = state();

    const qSubmittals = queryUsers(users, nextUserQuery, roles, groupsByMember)
      .keySeq()
      .toList();
    return state()
      .set('userQuery', nextUserQuery)
      .set('queriedUsers', qSubmittals);
  },

  queryUsers: ({ state }: AppStateActionParams): AppState => {
    const { users, userQuery, roles, groupsByMember } = state();
    const qUsers = queryUsers(users, userQuery, roles, groupsByMember);
    const queriedUsers = Immutable.List(qUsers.keys());
    return state().set('queriedUsers', queriedUsers);
  },

  initUsersQuery: ({ state }: AppStateActionParams): AppState => {
    const { users, roles, groupsByMember } = state();
    const userQuery = new UserQuery();

    const nextUserQuery = userQuery;
    const qSubmittals = queryUsers(users, nextUserQuery, roles, groupsByMember);

    return state()
      .set('userQuery', nextUserQuery)
      .set('queriedUsers', Immutable.List(qSubmittals.keys()));
  },
};

export default userQueryActions;
